import React, { useEffect } from 'react';
import { useState } from 'react';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { useSelector } from 'react-redux';
import { formatPrice } from "../utils/saleUtils";
import LoadingSpinner from '../components/LoadingSpinner';

const Invoice = () => {
    const {userid}=useSelector(state=>state.auth)
    const [invoiceItems, setInvoiceItems] = useState([]);
    const [loader, setloader] = useState(false);

    const fetchFeaturedMockups = async () => {
        try {
            setloader(true)
            const result = await apiClient.get(`/sales/?data=p`);
            setloader(false)
            if (result.ok) setInvoiceItems(result.data.results);   
        } catch (error) {
            
        }
        
        
      };
      useEffect(()=>{
        fetchFeaturedMockups()
      },[])

    return (
        <>
            <section>
                <div className="container">
                    <div className="row">
                        <div className="col-md-5 mb-2">
                            <h2 className=" mb-3" style={{ color: "#000000e6" }}>Invoice</h2>
                        </div>
                    </div>
                </div>
            </section>
            <div className='px-2'>
            <p>Your monthly invoice for mockups</p>
            {/* Your invoice content goes here */}
            <div className='px-3'>
                    {invoiceItems.length === 0 && !loader ? (
                        <p>Your cart is empty.</p>
                    ) : (

                        <ul className='px-0'>

                            {loader?<div className="d-flex justify-content-center mt-5">

<LoadingSpinner  color="#FF3E1F" />
</div>:
                            
                            invoiceItems.map((item, index) => (
                                <li key={index} className='d-flex gap-md-5 gap-3 flex-wrap flex-md-nowrap shadow    align-items-center  p-4 rounded-3 mb-3 ' style={{backgroundColor:"#fff"}}>
                                    
                                    
                                    <div>
                                        <h5 className='fw-bold '>Invoice Number</h5>
                                        <p className='mb-0'>{item.invoice_no}</p>
                                    </div>
                                    <div>
                                        <h5 className='fw-bold '>Price :</h5>
                                        <p className='mb-0'>{formatPrice(item.price)}</p>
                                    </div>
                                    <button className='btn grey-btn rounded-3 ms-auto '>Download</button>
                                </li>
                            ))}

                        </ul>
                    )}
                    
                   

                    </div>
        </div>
        </>
    );
};

export default Invoice;